import { mediaUrl } from "../../lib/api";
import { Reveal } from "../Reveal";
import { useLang } from "../../context/LanguageContext";
import { MapPin } from "lucide-react";

export function LocationSection({ course }) {
  const { t } = useLang();
  const img = course.location_image || course.gallery?.[course.gallery.length - 1] || course.hero_image;
  return (
    <section data-testid="course-location" className="bg-[#E9EFFA] py-20 md:py-28">
      <div className="px-6 md:px-12 max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <Reveal>
          <span className="overline">{t("location.overline")}</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#0B1220] mt-3">
            {course.location_name || course.city}
          </h2>
          <div className="mt-5 inline-flex items-start gap-2 text-[#0B1220]">
            <MapPin className="h-5 w-5 text-[#1452F0] mt-0.5" strokeWidth={1.5} />
            <span className="text-lg">{course.location_address}</span>
          </div>
          <p className="mt-6 text-[#5C6678] font-light leading-relaxed max-w-xl">{course.location_description}</p>

          {course.location_map_url && (
            <div className="mt-8 overflow-hidden rounded-sm border border-[#D5DEEE] aspect-[16/9]">
              <iframe
                data-testid="location-map"
                src={course.location_map_url}
                title="Mappa"
                className="w-full h-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          )}
        </Reveal>

        <Reveal delay={0.1} className="overflow-hidden rounded-sm">
          <img
            src={mediaUrl(img)}
            alt={course.location_name}
            className="w-full h-[420px] lg:h-[560px] object-cover"
          />
        </Reveal>
      </div>
    </section>
  );
}
